import '../../assets/css/event.css';
import EventsListSection from "./EventsListSection";

export default function Events() {

    document.title = "Events";
    return (
        <>
            <EventsListSection />
        </>
    );
}
